import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function AuthPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function signInWithGoogle() {
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin }
    });
    if (error) { setError(error.message); setLoading(false); }
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      background: 'var(--bg)',
      padding: '24px',
    }}>
      <div style={{ textAlign: 'center', marginBottom: 48 }}>
        <div className="text-3d" style={{
          fontFamily: 'var(--font-display)',
          fontSize: 42,
          fontWeight: 700,
          letterSpacing: '0.02em',
          color: 'var(--text)',
          lineHeight: 1,
        }}>
          <span style={{ display: 'inline-block', animation: 'slideFromLeft 0.55s cubic-bezier(0.18,0.89,0.32,1) both' }}>SHOP</span>
          <span style={{ display: 'inline-block', color: 'var(--orange)', animation: 'slideFromRightSm 0.55s cubic-bezier(0.18,0.89,0.32,1) both' }}>TRACK</span>
        </div>
        <div style={{ color: 'var(--text3)', fontSize: 13, marginTop: 8, animation: 'fadeUp 0.5s ease 0.35s both' }}>
          Body shop claim management
        </div>
      </div>

      <div style={{
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        padding: '32px 28px',
        width: '100%',
        maxWidth: 360,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        animation: 'fadeUp 0.5s ease 0.2s both',
      }}>
        <div style={{ fontSize: 18, fontWeight: 600, textAlign: 'center', marginBottom: 8 }}>
          Sign in to continue
        </div>

        <button
          className="btn btn-primary"
          onClick={signInWithGoogle}
          disabled={loading}
          style={{ padding: '14px 18px', fontSize: 15, width: '100%' }}
        >
          {loading ? (
            <div className="spinner" />
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
                <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" fill="#34A853"/>
                <path d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
                <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
              </svg>
              Sign in with Google
            </>
          )}
        </button>

        {error && (
          <div style={{ color: 'var(--red)', fontSize: 13, textAlign: 'center' }}>
            {error}
          </div>
        )}
      </div>

      <div style={{ color: 'var(--text3)', fontSize: 12, marginTop: 32, textAlign: 'center' }}>
        Sign in to access your shop's claims
      </div>
    </div>
  );
}
